<template>
    <div class="kiosk-spinner" aria-hidden="true">
        <span v-for="bar in 12" :key="bar" class="kiosk-spinner-bar"></span>
    </div>
</template>

<script>
// The kiosk's one spinner: twelve tapered bars around a ring, blue through
// violet, with the fade chasing round them — the mockup's spinner rather than
// Font Awesome's. Drawn wherever the kiosk is doing something on its own that
// the guest has to wait out: the "Now Starting" / "Now Closing" panel and the
// idle auto-reset, so the two never look like different products.
export default {
    name: 'KioskSpinner',
};
</script>

<style lang="scss" scoped>
$spinner-size: 96px;
$bar-colors: #38bdf8, #60a5fa, #818cf8, #a78bfa, #c084fc, #d8b4fe, #ddd6fe,
    #c7d2fe, #bfdbfe, #93c5fd, #60a5fa, #38bdf8;

.kiosk-spinner {
    position: relative;
    width: $spinner-size;
    height: $spinner-size;
}

.kiosk-spinner-bar {
    position: absolute;
    top: 0;
    left: 50%;
    width: 7px;
    height: 22px;
    margin-left: -3.5px;
    border-radius: 4px;
    transform-origin: 50% #{$spinner-size * 0.5};
    animation: kiosk-spinner-fade 1.2s linear infinite;

    @for $i from 1 through 12 {
        &:nth-child(#{$i}) {
            background: nth($bar-colors, $i);
            transform: rotate(#{($i - 1) * 30}deg);
            animation-delay: #{($i - 1) * -0.1}s;
        }
    }
}

@keyframes kiosk-spinner-fade {
    0% {
        opacity: 1;
    }
    100% {
        opacity: 0.2;
    }
}

/* A guest staring at a tablet that never stops moving is the point here, but
   respect the setting where the device asks for it. */
@media (prefers-reduced-motion: reduce) {
    .kiosk-spinner-bar {
        animation: none;
        opacity: 0.85;
    }
}
</style>
